<template>
<div class="chapter">
<div class="inner_page">
<h2 id="c3"><span class="calibre1">CHAPTER III</span>
<br class="calibre8"/>
<span class="h2line">ON TRACK OF A DEAL</span></h2>
<p class="calibre3">“What’s this?” asked the city editor.</p>
<p class="calibre3">“That story of amateur night,” replied Larry.</p>
<p class="calibre3">“Oh, yes, I’d forgotten all about it. I’m glad
you have the copy in early, as I want you to make
a quick trip out of town.”</p>
<p class="calibre3">“Any more floods?” asked Larry, thinking of
the big one he had helped cover when he was
a copy boy.</p>
<p class="calibre3">“Not this time; this is only to take a run over
to New Jersey, to a little town called Cranford.”</p>
<p class="calibre3">“What’s the matter out there?”</p>
<p class="calibre3">“I want you to see Professor Allen. He is
to deliver a lecture at the dinner of the Engineers’
Club to-night, and he has promised a copy
of his remarks in advance.”</p>
<p class="calibre3">Larry was soon on his way, crossing the Hudson
River on the ferry to the New Jersey side,
where he took a train for Cranford. He found
Professor Allen’s house without much trouble,
and inquired for the gentleman.</p>
<p class="calibre3">“I don’t believe you can see him,” replied the
girl who answered the door.</p>
<p class="calibre3">“Why not; isn’t he at home?” asked Larry.</p>
<div class="calibre2" id="Page_20" title="20"></div>
<p class="calibre3">“Well, he is and he isn’t,” replied the servant.
“You see he’s out in his laboratory making experiments,
which is what he’s most always up to,
and he hasn’t been in to his meals for a week.”</p>
<p class="calibre3">“Hasn’t he eaten for a week?” asked Larry, in
some surprise.</p>
<p class="calibre3">“Oh, bless your heart, of course he’s eaten,
but he will not come to the table. His wife has
to go out to the laboratory with a plate of victuals
and a cup of coffee, and fairly feed him.”</p>
<p class="calibre3">“What’s the trouble?”</p>
<p class="calibre3">“Oh, you see he’s working on a new invention.”</p>
<p class="calibre3">“What sort?” asked Larry, thinking he might
get a story out of it.</p>
<p class="calibre3">“Don’t ask me,” cried the servant, with a
laugh, for she evidently took Larry for some boy
on an errand. “It’s all about wheels and levers
and steam and electricity. As near as I can get
at, it’s a plan to make an automobile out of a
tea kettle.”</p>
<p class="calibre3">“Don’t you suppose I could see the professor?”
asked the young reporter.</p>
<p class="calibre3">“Well, you can try,” said the girl. “The laboratory
is that small white building down at the
far end of the yard. Go down there, and walk
right in. If you knock he’ll never answer. Mrs.
Allen has just fed him his breakfast, and perhaps
he’ll talk to you a little.”</p>
<div class="calibre2" id="Page_21" title="21"></div>
<p class="calibre3">Larry decided this was the only way of securing
what he wanted, so he made his way to the
laboratory, and, remembering the injunction,
entered the door and walked in.</p>
<p class="calibre3">He found himself in a large room, fairly filled
with machinery and appliances of all kinds.
Overhead there were shafts and pulleys, while
all about the sides were benches, lathes, wheels,
levers, handles, and springs of various sorts.</p>
<p class="calibre3">Down in one corner was an elderly gentleman,
in rather an old and ragged suit, at work over
a bench. He did not look up as Larry entered,
but called out:</p>
<p class="calibre3">“Come here and give me a hand with this. I’m
in a hurry.”</p>
<p class="calibre3">Larry looked around to see if the professor
could be speaking to anyone else, but, finding
that he was the only one in the room besides the
scientist, the lad concluded he was the one addressed.</p>
<p class="calibre3">“Hurry, please,” added Mr. Allen, looking
straight at Larry. “I am in the midst of an important
experiment.”</p>
<p class="calibre3">Thereupon Larry went to the bench. Mr.
Allen was holding one end of a long steel tube
from which radiated several smaller tubes of
glass. At one end of the steel tube was a rubber
pipe which was attached to a gas jet, and at the
other end of the tube there was another pipe
which was fastened to a water faucet.</p>
<p class="calibre3">“Turn on the gas a little more, and then help
me hold this tube,” spoke the scientist. “I am
generating steam.”</p>
<div class="calibre2" id="Page_22" title="22"></div>
<p class="calibre3">He spoke as though it was the most natural
thing in the world for Larry to be there, and give
him assistance. Larry recognized that Mr. Allen
was too much absorbed in his experiment to care
who helped him, so the boy lent a hand.</p>
<p class="calibre3">Larry turned the gas on, and then grasped one
end of the tube. Mr. Allen held the other. There
was a curious rumbling sound, followed by a
roar.</p>
<p class="calibre3">“Duck! She’s going to explode again!” cried
Mr. Allen, dropping his end of the tube, and
crawling under a table. Larry lost no time in
following his example. The next instant there
was a loud report, and pieces of the tube and
rubber hose were flying in all directions.</p>
<p class="calibre3">“It’s all over, you can come out now,” remarked
the scientist, in a quiet voice, a few seconds
later.</p>
<p class="calibre3">“Does it often act that way?” inquired Larry,
earnestly.</p>
<p class="calibre3">“That’s the twenty-seventh time it has blown
up,” replied the professor. “I guess the glass is
not strong enough for the steam.”</p>
<p class="calibre3">“Isn’t it dangerous?” ventured Larry.</p>
<p class="calibre3">“Dangerous? Of course it is! That’s what
I expect in this business. But I have another
tube here, and we’ll try it again. Just take your
coat off, and help me.”</p>
<p class="calibre3">“I’m afraid I haven’t time,” replied the reporter.
“I’m from the New York <i class="calibre9">Daily Leader</i>.
I came to get a copy of your speech.”</p>
<div class="calibre2" id="Page_23" title="23"></div>
<p class="calibre3">“What’s that?” inquired Mr. Allen, sharply.</p>
<p class="calibre3">Larry repeated his statement more fully.</p>
<p class="calibre3">“Bless my soul!” exclaimed the professor. “I
took you for my assistant’s son. He often helps
me. I didn’t get a good look at you, I was so
busy thinking about this steam problem. I hope
you were not hurt when the explosion came.”</p>
<p class="calibre3">“Not a bit,” replied Larry.</p>
<p class="calibre3">“Father! Father! Are you injured?” cried
a voice, and a woman, much excited, hurried
into the laboratory.</p>
<p class="calibre3">“Not a bit, my dear, not a bit,” replied the professor,
as he brushed the dust from his clothes.
“Another tube blew up, that’s all,” and he seemed
as cheerful as though the experiment had succeeded.</p>
<p class="calibre3">“Oh, those horrible, dangerous steam tubes!”
exclaimed the lady. Then she saw Larry, and,
observing he was a stranger, was about to withdraw.</p>
<p class="calibre3">“This is a reporter from the New York
<i class="calibre9">Leader</i>,” explained the scientist. “He has come
for a copy of my speech, and it’s a good thing he
did. I had forgotten all about delivering it to-night.
I guess I’ll go in the house, and get
ready. Come with me,” he added to Larry, “and
I’ll get the copy for you.”</p>
<div class="calibre2" id="Page_24" title="24"></div>
<p class="calibre3">“Thank goodness something happened to make
him come back to civilization,” remarked the
lady to Larry, as they walked toward the house.
“He has slept in that laboratory, and taken his
meals there ever since he started on this latest
idea. It’s a good thing you came along, and
awakened him to some realization that there’s
something in this world besides those terrible
steam tubes.”</p>
<p class="calibre3">“Perhaps the explosion did,” ventured Larry.</p>
<p class="calibre3">“That? It would take more than an explosion,”
the lady, who was Mr. Allen’s daughter,
replied. “He’s used to them.”</p>
<p class="calibre3">Larry went into the house, where, after some
search, Mr. Allen found a copy of his remarks,
which he gave to the young reporter.</p>
<p class="calibre3">“Come out and see me again some day,” the
scientist invited Larry. “We’ll try that experiment
again.”</p>
<p class="calibre3">“I’m afraid once is enough for me,” said Larry,
with a smile.</p>
<p class="calibre3">He reached his office shortly after noon, and,
handing in the copy of the speech, which had
been gotten in advance, so as to be set up ready
for the next day’s paper. Then he reported at
the desk, announcing to Mr. Emberg that he was
ready for another assignment.</p>
<p class="calibre3">“Take a run down to City Hall,” said the city
editor. “Mr. Newton is covering it to-day, but
he is busy on a story, and he telephoned in he had
no time to make all the rounds of the offices.
Just see if there are any routine matters he had
to overlook.”</p>
<div class="calibre2" id="Page_25" title="25"></div>
<p class="calibre3">It was the first time Larry had ever been assigned
to the municipal building alone. He was
familiar with most of the offices and knew some
of the officials by sight, as Mr. Newton had frequently
taken him around to “learn him the
ropes,” as he said. So Larry felt not a little
elated, and began to dream of the time when he
might have important assignments, such as looking
after city matters and politics, matters to
which New York papers pay great attention.</p>
<p class="calibre3">Larry went into several offices at the hall, and
found there was no news. It was rather a dull
day along municipal and political lines, and there
were few reporters around the building. Larry
knew some of them, who nodded to him in a
friendly way, and asked him whether there was
“anything new,” a reporter’s manner of inquiring
for news.</p>
<p class="calibre3">As Larry had nothing he said so, it being a
sort of unwritten law among newspaper men not
to beat each other on routine assignments, unless
there was some special story they were after.</p>
<p class="calibre3">It was almost closing hour at the hall, and
within a few minutes of the time the <i class="calibre9">Leader’s</i>
last edition went to press, that Larry entered the
anteroom of the City Comptroller’s office. He
hardly expected there would be any news, and
he knew if there was it was almost too late for
that day. However, he was tired, and, as there
were comfortable chairs in the office, he resolved
to have a few minutes’ rest, while waiting to
see the official or the chief clerk to ask if there
was anything new.</p>
<div class="calibre2" id="Page_26" title="26"></div>
<p class="calibre3">It was while sitting there, with his chair tilted
back against a thin partition, that Larry overheard
voices in somewhat loud conversation. At
first he paid little attention to the matter. But
when one of the voices became quite loud he
could not help hearing.</p>
<p class="calibre3">“I tell you I’ve got the whole plan outlined,
and we can all make big money by it,” someone
remarked. “I know the lay of the land. It’s
up in the Bronx.”</p>
<p class="calibre3">At that Larry began to take some notice, as
he remembered he and his mother were interested
in some Bronx property.</p>
<p class="calibre3">“The deal is going through, then?” asked another
man.</p>
<p class="calibre3">“Sure.”</p>
<p class="calibre3">Now Larry had no intention of eavesdropping,
and, if he had thought the conversation was of a
private nature, he would have moved away. But
it seemed the men had nothing to conceal, for
they talked loudly. They were probably unaware
that a transom over the door of the room where
they were, was open.</p>
<p class="calibre3">“What makes you so sure the land will be valuable?”
asked another voice.</p>
<p class="calibre3">“Because I know it,” came the answer from
the one who had first spoken. “There’s going
to be an ordinance introduced in the Common
Council soon. Now all we have to do is to buy
up all the lots——” What followed was in a
low tone, and Larry could not hear. Then the
voice went on: “It’s a great game, for it will
take our votes to pass the ordinance, see?”</p>
<div class="calibre2" id="Page_27" title="27"></div>
<p class="calibre3">“Won’t there be some danger?” asked someone.</p>
<p class="calibre3">“Not a bit. There’s only one hitch. I’ve been
looking the thing up, and I find that the most
valuable strip of land in the whole tract is owned
by some man up New York State.”</p>
<p class="calibre3">“Who is he?”</p>
<p class="calibre3">“Something like Pexter or Wexter,” was the
reply, whereat Larry felt his heart beating
strongly. Suppose it should happen to be the
land for which his mother held the deed?</p>
<p class="calibre3">“Can we put the deal through?” several asked
of the man who was doing the most talking.</p>
<p class="calibre3">“Sure we can,” was the answer. “Alderman——”</p>
<p class="calibre3">“Hush! Not so loud!” cautioned a voice.</p>
<p class="calibre3">“Close that transom,” ordered someone, and
then Larry moved away, fearing the men might
come out, and find him listening. He wanted to
know more of the matter, for he felt sure some
underhanded game was afoot.</p>
<p class="calibre3">That afternoon, on the way home, Larry told
Mr. Newton of what he had heard.</p>
<p class="calibre3">“I’ll bet there’s some sort of a deal on,” said
the older reporter. “Glad you happened to overhear
that, Larry. I’ll get busy on the tip, and
maybe we can block the game.”</p>
<div class="calibre2" id="Page_28" title="28"></div>
<div class="pg-boilerplate" id="calibre_pb_0"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?4b84edd8